// Волна аудио для плеера: N пиков 0..1. Генерируется отправителем при заливке
// (едет в зашифрованных метаданных вложения) либо декодом на приёмнике для
// старых сообщений без waveform.

export const WAVE_BARS = 96;

// max|амплитуды| по корзинам + нормализация; диапазон сжат корнем (тихо/громко
// на глаз не так контрастно), floor — чтобы паузы не проваливались в ноль.
const WAVE_FLOOR = 0.15;

export function peaksFromAudioBuffer(
    audio: AudioBuffer,
    bars = WAVE_BARS
): number[] {
    const data = audio.getChannelData(0);
    if (!data.length) {
        return new Array(bars).fill(WAVE_FLOOR);
    }
    const peaks: number[] = [];
    for (let i = 0; i < bars; i++) {
        const from = Math.floor((i * data.length) / bars);
        const to = Math.max(
            from + 1,
            Math.floor(((i + 1) * data.length) / bars)
        );
        let peak = 0;
        for (let j = from; j < to; j++) {
            peak = Math.max(peak, Math.abs(data[j]));
        }
        peaks.push(peak);
    }
    const max = Math.max(...peaks, 0.001);
    return peaks.map(
        (p) => Math.round(Math.max(WAVE_FLOOR, Math.sqrt(p / max)) * 100) / 100
    );
}

// Декод блоба (objectURL) в волну + длительность. null при провале (битый
// файл, неподдерживаемый кодек).
export async function decodeWaveform(
    blobUrl: string
): Promise<{ peaks: number[]; duration: number } | null> {
    try {
        const buf = await (await fetch(blobUrl)).arrayBuffer();
        const ctx = new AudioContext();
        try {
            const audio = await ctx.decodeAudioData(buf);
            return {
                peaks: peaksFromAudioBuffer(audio),
                duration: audio.duration,
            };
        } finally {
            void ctx.close().catch(() => {});
        }
    } catch {
        return null;
    }
}
